var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('el-collapse',{staticClass:"my-collapse",attrs:{"value":_vm.showCollapse}},[_c('el-collapse-item',{attrs:{"name":1,"title":"移入公海审批抄送"}},[_c('IntoOpenSea')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }